// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var GraphqlTag = require("graphql-tag");


var ApolloCacheInmemory = require("apollo-cache-inmemory");
var InMemoryCache = ApolloCacheInmemory.InMemoryCache;
var IntrospectionFragmentMatcher = ApolloCacheInmemory.IntrospectionFragmentMatcher;
var ApolloClient = require("apollo-client").ApolloClient;
var ApolloLink = require("apollo-link").ApolloLink;
var HttpLink = require("apollo-link-http").HttpLink;
var WebSocketLink = require("apollo-link-ws").WebSocketLink;
var getOperationAST = require("graphql").getOperationAST;
/* var gql = require("graphql-tag"); */
  
;

var amendementFragment = "\n    fragment AmendementFragment on Amendement {\n      auteur {\n        ...AuteurFragment\n      }\n      bibard\n      bibardSuffixe\n      cosignataires {\n        ...AuteurFragment\n      }\n      cosignatairesMentionLibre {\n        ...CosignatairesMentionLibreFragment\n      }\n      dispositif\n      etat\n      exposeSommaire\n      legislature\n      numero\n      numeroLong\n      numeroReference\n      organeAbrv\n      place\n      placeReference\n      sortEnSeance\n    }\n  ";

var auteurFragment = "\n    fragment AuteurFragment on Auteur {\n      civilite\n      estRapporteur\n      estGouvernement\n      groupeTribunId\n      nom\n      photoUrl\n      prenom\n      qualite\n      tribunId\n    }\n  ";

var cosignatairesMentionLibreFragment = "\n    fragment CosignatairesMentionLibreFragment on CosignatairesMentionLibre {\n      titre\n    }\n  ";

var discussionFragment = "\n    fragment DiscussionFragment on Discussion {\n      amendements {\n        ...EnveloppeAmendementFragment\n      }\n      bibard\n      bibardSuffixe\n      divisions {\n        ...DivisionFragment\n      }\n      legislature\n      numeroProchainADiscuter\n      organe\n      pages {\n        ...PageFragment\n      }\n      titre\n      type\n    }\n  ";

var divisionFragment = "\n    fragment DivisionFragment on Division {\n      # amendements\n      place\n      position\n    }\n  ";

var elementOrdreDuJourFragment = "\n    fragment ElementOrdreDuJourFragment on ElementOrdreDuJour {\n      textBibard\n      textBibardSuffixe\n      textTitre\n    }\n  ";

var enveloppeAmendementFragment = "\n    fragment EnveloppeAmendementFragment on EnveloppeAmendement {\n      alineaLabel\n      amendement {\n        ...AmendementFragment\n      }\n      auteurGroupe\n      auteurLabel\n      discussionCommune\n      discussionCommuneAmdtPositon\n      discussionCommuneSsAmdtPositon\n      discussionIdentique\n      discussionIdentiqueAmdtPositon\n      discussionIdentiqueSsAmdtPositon\n      missionLabel\n      numero\n      parentNumero\n      place\n      position\n      sort\n    }\n  ";

var pageFragment = "\n    fragment PageFragment on Page {\n      body\n      numero\n      slug\n      titre\n    }\n  ";

var prochainADiscuterFragment = "\n    fragment ProchainADiscuterFragment on ProchainADiscuter {\n      bibard\n      bibardSuffixe\n      legislature\n      nbrAmdtRestant\n      numAmdt\n      organeAbrv\n    }\n  ";

var amendementUpsertedSubscriptionQuery = GraphqlTag("\n      subscription onAmendementUpserted {\n        amendementUpserted {\n          ...AmendementFragment\n        }\n      }\n      " + (String(amendementFragment) + ("\n      " + (String(auteurFragment) + ("\n      " + (String(cosignatairesMentionLibreFragment) + "\n    "))))));

var createAmendementUpsertedSubscriptionQuery = (
function () {
  return {
    query: amendementUpsertedSubscriptionQuery,
    variables: {
    }
  };
}
  );

var createGraphqlClient = (
function (httpUrl, wsUrl) {
  var link = ApolloLink.split(
    function (operation) {
      var operationAST = getOperationAST(operation.query, operation.operationName);
      return !!operationAST && operationAST.operation === "subscription";
    },
    new WebSocketLink({
      uri: wsUrl,
      options: {
        reconnect: true, //auto-reconnect
        // // carry login state (should use secure websockets (wss) when using this)
        // connectionParams: {
        //   authToken: localStorage.getItem("Meteor.loginToken")
        // }
      },
    }),
    new HttpLink({ uri: httpUrl })
  );
  // Finally, create your ApolloClient instance with the modified network interface
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: link
  });
}
  );

var discussionQuery = GraphqlTag("\n      query Discussion($bibard: String!, $bibardSuffixe: String, $legislature: Int!, $organe: String!) {\n        discussion(bibard: $bibard, bibardSuffixe: $bibardSuffixe, legislature: $legislature, organe: $organe) {\n          ...DiscussionFragment\n        }\n      }\n    " + (amendementFragment + (auteurFragment + (cosignatairesMentionLibreFragment + (discussionFragment + (divisionFragment + (enveloppeAmendementFragment + pageFragment)))))));

var createDiscussionQuery = (
function (bibard, bibardSuffixe, legislature, organe) {
  legislature = parseInt(legislature);
  return {
    query: discussionQuery,
    variables: {
      bibard: bibard,
      bibardSuffixe: bibardSuffixe,
      legislature: legislature,
      organe: organe
    }
  };
}
  );

var ordreDuJourQuery = GraphqlTag("\n      query OrdreDuJour($legislature: Int!, $organe: String!) {\n        ordreDuJour(legislature: $legislature, organe: $organe) {\n          ...ElementOrdreDuJourFragment\n        }\n      }\n    " + elementOrdreDuJourFragment);

var createOrdreDuJourQuery = (
function (legislature, organe) {
  legislature = parseInt(legislature);
  return {
    query: ordreDuJourQuery,
    variables: {
      legislature: legislature,
      organe: organe
    }
  };
}
  );

var prochainADiscuterUpsertedSubscriptionQuery = GraphqlTag("\n      subscription onProchainADiscuterUpserted {\n        prochainADiscuterUpserted {\n          ...ProchainADiscuterFragment\n        }\n      }\n    " + prochainADiscuterFragment);

var createProchainADiscuterUpsertedSubscriptionQuery = (
function () {
  return {
    query: prochainADiscuterUpsertedSubscriptionQuery,
    variables: {
    }
  };
}
  );

var deleteGraphqlClient = (
function (graphqlClient) {
  // TODO: Is there something to do?
}
  );

exports.amendementFragment = amendementFragment;
exports.auteurFragment = auteurFragment;
exports.cosignatairesMentionLibreFragment = cosignatairesMentionLibreFragment;
exports.discussionFragment = discussionFragment;
exports.divisionFragment = divisionFragment;
exports.elementOrdreDuJourFragment = elementOrdreDuJourFragment;
exports.enveloppeAmendementFragment = enveloppeAmendementFragment;
exports.pageFragment = pageFragment;
exports.prochainADiscuterFragment = prochainADiscuterFragment;
exports.amendementUpsertedSubscriptionQuery = amendementUpsertedSubscriptionQuery;
exports.createAmendementUpsertedSubscriptionQuery = createAmendementUpsertedSubscriptionQuery;
exports.createGraphqlClient = createGraphqlClient;
exports.discussionQuery = discussionQuery;
exports.createDiscussionQuery = createDiscussionQuery;
exports.ordreDuJourQuery = ordreDuJourQuery;
exports.createOrdreDuJourQuery = createOrdreDuJourQuery;
exports.prochainADiscuterUpsertedSubscriptionQuery = prochainADiscuterUpsertedSubscriptionQuery;
exports.createProchainADiscuterUpsertedSubscriptionQuery = createProchainADiscuterUpsertedSubscriptionQuery;
exports.deleteGraphqlClient = deleteGraphqlClient;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/apollo.re
// module id = 117
// module chunks = 0